import { useSelector } from 'react-redux';

import { pricingSelectors } from '../../../../store/modules/pricing';
import { userSelectors } from '../../../../store/modules/user';

const useSeasonalDiscount = () => {
  const sale = useSelector(pricingSelectors.selectSale);

  const isNewUser = useSelector(userSelectors.selectIsUserNew);
  return sale && isNewUser ? sale : undefined;
};

export default useSeasonalDiscount;
